import * as React from 'react';

import { useDeviceCondition } from '../../../../../../hooks';
import { AnimationLayout, AnimationElement } from '../../../../../common/Animation';

import { layoutAnimationConfig } from './constants';
import * as styles from './Layout.css';

interface ILayoutProps {
  price: React.ReactNode;
  fromPackage: React.ReactNode;
  packages: React.ReactNode;
  singlePackage: React.ReactNode;
}

export const Layout = ({ price, fromPackage, packages, singlePackage }: ILayoutProps) => {
  const rootStyle = useDeviceCondition(styles['desktop'], styles['mobile']);

  return (
    <div className={rootStyle}>
      <AnimationElement layout="position" className={styles['publication']}>
        <div className={styles['price']}>{price}</div>
      </AnimationElement>

      {singlePackage && (
        <AnimationElement layout="position" className={styles['single_package']}>
          {singlePackage}
        </AnimationElement>
      )}

      {fromPackage && (
        <AnimationElement layout="position" className={styles['from_package']}>
          {fromPackage}
        </AnimationElement>
      )}

      <AnimationLayout>
        {packages && (
          <AnimationElement layout="position" className={styles['packages']} {...layoutAnimationConfig}>
            {packages}
          </AnimationElement>
        )}
      </AnimationLayout>
    </div>
  );
};
